import { isPageLoadMetricData, isPageSegmentLoadMetricData } from '../../metric/types';
export var eventInitial = function eventInitial(_config, data) {
  if (!isPageLoadMetricData(data) && !isPageSegmentLoadMetricData(data)) {
    return null;
  }
  return {
    'event:initial': data.isInitial
  };
};